import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useFormContext } from "react-hook-form";
import { ConsumablesFormStepSection } from "@jti/ui/components/ConsumablesFormStepSection";
import { Icon } from "@jti/ui/components/Icon";
import { RadioCard } from "@jti/ui/components/RadioCard";
import Subscription from "@jti/ui/icons/subscription.svg";
import { useTranslations } from "@jti/ui/providers/useTranslations";
import { MonthlyPurchaseButtonContent } from "../../../../components/MonthlyPurchaseButtonContent";
import { ConsumablesPurchaseTypeSectionTitle } from "./ConsumablesPurchaseTypeSectionTitle";
export const ConsumablesPurchaseTypeSection = ({ groupName, step, onChange, isOnetimePurchaseDisabled = false, isSubscriptionUnavailable = false, value, }) => {
    const { __ } = useTranslations();
    const { register } = useFormContext();
    const handleFrequencyChange = (event) => {
        const selectedValue = event.target.value;
        const isPurchaseTypeValid = selectedValue === "regular" || selectedValue === "subscription";
        if (!isPurchaseTypeValid) {
            event.preventDefault();
            console.error('Invalid purchase type selected. Only "regular" or "subscription" is allowed. Current selection value:', selectedValue);
            return;
        }
        const isSuccess = onChange(selectedValue);
        if (!isSuccess) {
            event.preventDefault();
        }
    };
    const registerProps = register(groupName, { onChange: handleFrequencyChange });
    return (_jsxs(ConsumablesFormStepSection, { title: _jsx(ConsumablesPurchaseTypeSectionTitle, { step: step, purchaseType: value }), "data-testid": "frequency-options", children: [_jsx(RadioCard, { groupName: groupName, value: "regular", title: __("consumablesForm.purchase_type.regular"), isDisabled: isOnetimePurchaseDisabled, ...registerProps }), _jsx(RadioCard, { groupName: groupName, value: "subscription", title: __("consumablesForm.purchase_type.subscription"), icon: _jsx(Icon, { component: Subscription, width: "27px", height: "27px" }), description: _jsx(MonthlyPurchaseButtonContent, {}), isUnavailable: isSubscriptionUnavailable, ...registerProps })] }));
};
//# sourceMappingURL=ConsumablesPurchaseTypeSection.js.map